// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconLinearLovely = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '17',
      height: '16',
      viewBox: '0 0 17 16',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13.5734 5.39331C13.5734 5.67331 13.5534 5.94664 13.5201 6.20664C13.2134 6.07331 12.8801 5.99998 12.5268 5.99998C11.7134 5.99998 10.9934 6.39331 10.5468 6.99331C10.0934 6.39331 9.37341 5.99998 8.56008 5.99998C7.19341 5.99998 6.08675 7.11331 6.08675 8.49331C6.08675 10.28 7.03342 11.6466 8.08675 12.5733C8.05342 12.5933 8.02009 12.6 7.98676 12.6133C7.78676 12.6867 7.45342 12.6867 7.25342 12.6133C5.52675 12.02 1.66675 9.56664 1.66675 5.39331C1.66675 3.55331 3.14674 2.06665 4.97341 2.06665C6.06008 2.06665 7.02008 2.58664 7.62008 3.39331C8.22674 2.58664 9.18674 2.06665 10.2667 2.06665C12.0934 2.06665 13.5734 3.55331 13.5734 5.39331Z',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15 8.49333C15 11.6133 12.1133 13.4533 10.82 13.8933C10.6667 13.9467 10.42 13.9467 10.2667 13.8933C9.71333 13.7067 8.86667 13.26 8.08667 12.5733C7.03334 11.6467 6.08667 10.28 6.08667 8.49333C6.08667 7.11333 7.19333 6 8.56 6C9.37333 6 10.0933 6.39333 10.5467 6.99333C10.9933 6.39333 11.7133 6 12.5267 6C12.88 6 13.2133 6.07333 13.52 6.20667C14.3933 6.59333 15 7.46666 15 8.49333Z',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
  );

export { IconLinearLovely };
